import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Box, Paper, Typography, Button } from "@mui/material";
import ActivityBar from "../../../components/Reusable/ActivityBar/ActivityBar";
import RoutineStyle from "../../../components/Routine&Performance/RoutineUpload.module.css";
import StrategyStyle from "./strategy.module.css";
import SectionSliderstrategy from "../../../components/Reusable/SectionSlider/SectionSliderstrategy";
import { sections, sectionPaths } from '../../../constants/SectionDataStrategy';
import CustomDialog from "../../../components/Reusable/DialogBox/CustomDialog";
import CustomTable from "../../../components/Reusable/DialogBox/CustomTable";
import { apiService } from "../../../api/apiService";
import VisionStrategySection from "./VisionStrategySection";
import CustomTableUser from "../../../components/Reusable/DialogBox/CustomTableUser";
import VisionStrategySectionUser from "./VisionStrategySectionUser";
import { useMsal } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';


const StrategyValueUser: React.FC = () => {
  const { instance } = useMsal();
  const management = localStorage.getItem("management") || "Default Location Name";
  const [open, setOpen] = useState(false);
  const [openUpload, setOpenUpload] = useState(false);
  const [tableData, setTableData] = useState<any[]>([]);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const breadcrumbs = [
    <Link key="1" to="/" onClick={(e) => e.preventDefault()}>
      Home
    </Link>,
    <Link key="2" to="/" onClick={(e) => e.preventDefault()}>
      Evidence Upload
    </Link>,
    <Link key="3" to="/operations/strategy-value-creation/">
      Vision & Strategy planning
    </Link>,
    <Typography key="4">{management}</Typography>,
  ];

  // Fetch data from the API
  const fetchData = useCallback(async () => {
    try {
      const response = await apiService("/strategy/filter_vision_n_strategy", "GET", {
        management,
        section_name: "BSC KPIs",
      },
      undefined, 
      instance as PublicClientApplication
    );

      console.log("API Response:", response); // Debug: Check API response

      if (response && response.data) {
        setTableData(response.data); // Update state with fetched data
        console.log("Table Data Updated:", response.data); // Debug: Check state update
      } else {
        console.error("Unexpected API response structure:", response);
      }
    } catch (error) {
      console.error("Failed to fetch Vision N Strategy:", error);
    }
  }, [management]);

  // Fetch data on component mount and when fetchData changes
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div>
      <ActivityBar breadcrumbs={breadcrumbs} />

      <SectionSliderstrategy
        sections={sections}
        sectionPath={sectionPaths}
        highlightSection="Vision, Mission & Mission KPIs"
        highlightColor="#D7A833"
        defaultColor="#666"
      />

      <Box sx={{ padding: '10px 20px' }}>
        <VisionStrategySectionUser management={encodeURIComponent(management)} section_name={encodeURIComponent("Vision & Strategy")} />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '98%', mt: 2, mb: 2 }}>
          <Box>
            <Typography sx={{ p: 1, pt: '0' }} className={RoutineStyle.routineHeading}>
              BSC Mission KPIs
            </Typography>
            <Typography sx={{ p: 1, pb: '0', pt: '0', fontSize: '14px' }}>
              Question : BSC Long-term Objectives and KPIs contribute to GBS Mission KPIs
            </Typography>
          </Box>
        </Box>

        {/* CustomDialog for adding new data */}
        <CustomDialog
          open={open}
          openUpload={openUpload}
          setOpenUpload={setOpenUpload}
          onClose={handleClose}
          title="Mission KPI"
          management={management}
          section_name="BSC KPIs"
          onSuccess={fetchData} // Pass fetchData to refresh the table after upload
        />

        {/* CustomTable to display the data */}
        <CustomTableUser management={management} section_name="BSC KPIs" data={tableData} />
      </Box>
    </div>
  );
};

export default StrategyValueUser;